import { CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { useNavigate } from 'react-router-dom';

export default function Success() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6">
      <Card className="max-w-md w-full p-8 text-center space-y-6 fade-in">
        <div className="h-20 w-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
          <CheckCircle2 className="h-12 w-12 text-green-600" />
        </div>
        <div>
          <h2 className="text-3xl font-bold mb-3" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
            Erfolgreich unterschrieben!
          </h2>
          <p className="text-zinc-600 leading-relaxed">
            Vielen Dank für Ihre Unterschrift. Das unterschriebene Dokument wurde per E-Mail an den Absender gesendet.
          </p>
        </div>
        <div className="pt-4">
          <Button
            data-testid="back-home-button"
            onClick={() => navigate('/')}
            className="bg-zinc-950 text-white hover:bg-zinc-800 w-full h-12"
          >
            OK
          </Button>
        </div>
        <div className="text-sm text-zinc-500 pt-4 border-t border-zinc-200">
          <p>Entwickelt von Scholze-Kurz & Kurz Immobilien GmbH</p>
        </div>
      </Card>
    </div>
  );
}